const en = {
  question:{
    indication : "Please give us your comments on the following biblical text: "
  },
  link: {
    title: "Very interesting article on Jehovah's Witnesses official website:",
    subject: "Marry “Only in the Lord”—Still Realistic?"
  },
  messages: {
    usernameAlert: {
      text: "Your username must be different from your real name. It should not reflect your real first or last name, or the username you use on your social networks. Include only letters and numbers, no spaces and special characters."
    },
    accept: '',
    loading_subscription_state: "Loading subcription state...",
    error_subscription_detail: "Error getting your subscription status, reload or try later.",
    renewal: {
      title: "Automatic renewal",
      intro: "If you want to cancel your automatic renewal, click the button below:",
      empty: "Your automatic renewal is already cancelled",
      alert: {
        title: "Automatic renewal cancelled",
        text: "Your automatic renewal has been cancelled."
      }
    },
    choose_step: "Scroll to next step",
    ads: {
      thankyou: "Thank you for choosing JWperfectmatch",
      since: "Building JW relationships since March 2020",
      share: "Share JWperfectmatch"
    },
    userTypes: {
      title: "What types of users do we have on JWperfectmatch?",
      premium: {
        title: "Premium User",
        type: "Golden point",
        content_1: "By subscribing, you can choose to become a premium user by clicking on the designated box. Being a premium user will allow you to receive written responses, as well as calls and video calls from all subscribed users. In addition, you can receive written responses from all non-subscribed users. The cost of this option is $14/month with automatic renewal.",
        content_2: "If you are very interested in a non-subscribed user and wish to receive a written response and make calls or video calls, you have the option of sending a gift. By doing so, you can call or video call that user for a period of seven days from the date you purchased the gift.",
        content_3: "Eventually we can send you an offer to subscribe as a premium user under the payment method of US $ 15 for 15 days with automatic renewal. This convenient offer will allow you to enjoy all the advantages of being a premium user for a lower cost. You can cancel the automatic renewal of this subscription anytime you want,  following the procedure established within the Terms of Use under the section: <b>Can I cancel the automatic renewal?</b> Within this section you will find the procedure to follow to cancel the automatic renewal of your subscription. You should consider that if you buy the subscription US $ 15 for fifteen days you will not be able to request a refund. You must agree to this condition, otherwise you should not buy this subscription."
      },
      subscribed: {
        title: "Subscribed User",
        type: "Blue point",
        content: "By subscribing to any of our monthly, quarterly, semi-annual or annual plans, you become a subscribed user. Being a subscribed user will allow you to receive written responses, calls, or video calls from other subscribed users. If you want to contact other non-subscribed users, you can do so by sending default messages or Emojis. If you are very interested in a non-subscribed user and wish to receive a written response and make calls or video calls, you have the option of sending a gift. By doing so, you can receive written messages and call or video call that user for a period of seven days from the purchase of the gift."
      },
      none: {
        title: "Non-subscribed User",
        content: "By registering and creating your JWperfectmatch profile, you will have access to the search for other users, whether subscribed or non-subscribed within the website. You can contact other users through the chat platform and send default messages and Emojis to express yourself. In order to make calls or video calls with other subscribed users, you must subscribe to any of our accessible subscription plans with automatic renewal. This will give you many advantages to meet other users in whom you are interested."
      },
      gift: {
        title: "Gift",
        content_1: "This option is available and accessible for subscribed users. You can send a gift to that non-subscribed user in whom you are interested. If you are a Premium user and you want to call or video call a non-subscribed user, you can do so by sending a gift. This way, you can contact the non-subscribed user through calls and video calls for a period of seven days from the date you purchased the gift. Upon receiving a gift from you, the non-subscribed user and you can contact each other through written messages, calls, or video calls. A non-subscribed user can only contact via chat, calls or video calls users who have sent him/her a gift.",
        content_2: "If you are a subscribed user and wish to receive and send written messages, and call or video call a non-subscribed user, you can do so by sending a gift. This way, you can contact the non-subscribed user through calls and video calls for a period of seven days from the date you purchased the gift. Upon receiving a gift from you, the non-subscribed user and you can contact each other through written messages, calls, or video calls. A non-subscribed user can only contact via chat, calls or video calls users who have sent him/her a gift."
      },
      gift_subscription: {
        title: "CONGRATULATIONS!",
        message: "You have been selected to receive a free gift from your Brothers & Sisters here at JWperfectmatch, of 15 days Premium Subscription. <br> Thank you for being a loyal customer at JWperfectmatch. We hope you enjoy our gift.&#127873;",
        button_accept: "Open my gift &#127873;",
        button_cancel: "Cancel",
        confirm: "Gift Redeemed"
      },
      upgrade: {
        title: "Subscription upgrade",
        content_1: "If you want to go from the standard subscription to the Premium one, you can do it whenever you want by paying the following flat rates: 1-month subscription: US $ 14.00; 3-month subscription: US $ 39.99; Six-month subscription: US $ 79.99 and twelve-month or one-year subscription; US $ 155.00.",
        content_2: "These flat rates will be charged in addition to the payment of your subscription and will be applied at any time you decide to change from standard to Premium subscription.",
        content_3: "You are not allowed to request a refund for the payment of these fees. You agree that you will not be able to request a refund of the payment of the previous fixed fees."
      }
    },
    emailconfirm: {
      title: "Please confirm your email address.",
      description: "On JWperfectmatch, we want to provide you with the highest security in the creation of your user profile. For this reason, we have sent an email to your address {email}. Please enter the 4-digits confirmation code provided in the email, into the field below:",
      legend: "Please  remember to check your spam or junk folder",
      help_message: "Did not receive the email?",
      verify: "Verify that the email address is correct and",
      resend: "resend email.",
      button: "Validate",
      resendMessage: "We have resend you a new code",
      verifyError: "Email verification error, please confirm that you inserted a valid code.",
      exceeded: "You have exceeded the number of attempts allowed."
    },
    connectycube: {
      error: {
        title: 'Sorry!',
        description: 'We are experiencing technical difficulties. Please try again later',
        action: 'Back to profile'
      },
    },
    languages: {
      english: "English",
      spanish: "Spanish",
      short: {
        english: "EN",
        spanish: "ES"
      }
    },
    user_profile: {
      about_me: {
        age: {
          label: 'Age',
          years: '{years} years'
        }
      },
      about_my_couple: {
        age_range: {
          label: 'Age range',
          range: '{from} - {to} years'
        }
      }
    },
    general: {
      subscription15days: {
        title: 'Limited time offer!',
        content: '15 days  Premium subscription for only US$15 with automatic renewal. Get unlimited talk and text  with another subscribed members and unlimited chat with all the users.',
        button: 'Go premium for only US$15'
      },
      blocked_profile: 'This user is in invisible mode. Not available',
      expired_subscription: "Your subscription payment was unsuccesful, please update your billing information",
      phone_comfirm: {
        title: "IMPORTANT",
        message: "To continue please confirm your mobile number",
      },
      title_jw: "Ready to start? It will be exciting to start meeting other users!",
      subscribe_button_jw: "Start now!",
      subscribe_jw: "Ready to Start JW Dating?",
      actions: "Actions",
      chat_not_allowed: "You are not allowed to chat with this person.",
      tell_your_friends_btn: "Tell your friends about JWperfectmatch!",
      page_title: "Jehovah's witnesses dating site",
      auth_failed: "The password or email are incorrect",
      auth_banned: "User not found, please contact support",
      home: "Home",
      support: "Support",
      security: "Safety",
      privacy: "Privacy Policy",
      terms: "Terms of Use",
      contact: "Contact Us",
      tips: "JW Guidance",
      engagement: "JW Dating",
      conduct: "JW Conduct",
      rights: "All Rights reserved",
      login: "Log In",
      log_in: "Log In",
      login_account: "Log In to your account",
      forgot_password: "Have you forgotten the password?",
      stay_connected: "Keep me logged in.",
      return_home: "Return homepage",
      are_you_member: "Not a member yet?",
      sign_up_free: "Sign up free",
      day: "days",
      sign_up_message:
        "Create your FREE profile and find your perfect match today!",
      i_am: "I am a",
      man: "Man",
      men: "Men",
      women: "Women",
      woman: "Woman",
      female_is: "She is",
      male_is: "He is",

      age_range: "Age range",
      subscription_title: "Subscription",
      every15days: "Every 15 days",
      sign_up_now: "Sign up now",
      already_user: "Already a member?",
      subscribe_free_now:
        "Subscribe for free now, it will be exciting to start meeting other users!",
      subscribe_free:
        "Create your FREE profile and find your perfect match today!",
      subscribe_now: "Subscribe now",
      continue_reading: "Read more",
      see_more: "See more",
      see_my_profile: "See my profile",
      mobile_verified: "Mobile verified",
      see_profile: "See profile",
      mobile_no_verified: "Mobile not verified",
      years: "years old",
      verified_now: "Confirm your mobile now",
      connection: "Connection",
      last_connection: "Last Connection",
      now: "Now",
      my_activity: "My activity",
      search: "Search",
      messages: "Messages",
      visits_to_your_profile: "Profile visits",
      favorites: "Favorites",
      reciprocal_favorites: "Mutual Favorites",
      invitations: "Invitations",
      invitations_message: "In this section, you will find the users that have added you as a favorite, greeted you, or sent you a gift.",
      tell_your_friends: "Tell your friends",
      visits_title: "Profile visits",
      subscribe: "Subscribe",
      profile: "Profile",
      logout: "Log out",
      edit_profile: "Edit my profile",
      subscription_status: "Subscription status",
      subscription_message:
        "You are currently an active subscriber of the dating site for single Jehovah's Witnesses JWperfectmatch.",
      subscription_info: "Subscription info",
      payment_method: "Payment method",
      subscription: "Subscription",
      subscription_date: "Subscription date",
      period: "Period",
      expiration_date: "Expiration date",
      automatic_renewal: "Automatic renewal",
      currency: "Currency",
      amount: "Subscription payment",
      last_payment: "Last payment",
      locked_profiles: "Blocked profiles",
      subscription_renewal: "Subscription Renewal",
      send: "Send",
      loading_messages: "Loading messages...",
      send_gift: "Send gift",
      has_sent_you_a_gift: 'has sent you a gift',
      compatibility: "Compatibility",
      no_available: "No Available",
      greet: "Greet",
      touch: "Contact",
      add_to_favorites: "Add to favorites",
      add_favorites: "has added you to his favorites",
      remove_to_favorites: "Remove from favorites",
      has_greeted_you: "has greeted you",
      more: "More",
      block_user: "Block user",
      report_bullying: "Report harassment",
      user_types: "Types of users",
      to_see_and_meet: "To see and meet up more users.",
      visited_profile: "Your profile has been visited",
      visits_today: "Today",
      visits_last_week: "Last week",
      visits_monthly: "This month",
      visits_3_months: "Last 3 months",
      search_users: "Search users...",
      select_an_option: "Select an option",
      previous: "Previous",
      next: "Next",
      last_modification: "Last profile modification",
      profile_creation: "Profile creation date",
      match_filter: "Filter by match",
      typing: "Typing",
      reply: "Send a reply",
      favorites_status_message:
        "We have found people that meet your search criteria.",
      subscribe_today: "Subscribe now!",
      subscribe_message:
        "Get access to voice calls, unlimited video calls, and messages in a safe environment. You’ll love it!",
      favotites_added_message: "Have added you to {gender} favorites",
      subscribe_message_mini: "It will be exciting to start meeting other users!",
      days_ago: "{days} days ago",
      smiles_sended_message: "Have sent you a smile",
      subscription_gifts_message: "Gift subscriptions",
      blocked_users_message:
        "These are the users that you have blocked. Remember that you can unblock any user at any time. You are always in control!",
      unlock: "Unblock",
      you_are: "You are",
      related_to: "compatible with",
      related_to_me: "compatible with you.",
      contacts_to_see_message:
        "We have more than 20 contacts that we think you should see.",
      more: "More",
      added_to_favorites: "You have added this user to your favories list.",
      removed_from_favorites: "This user is not your favorite anymore.",
      see_now: "See now",
      see_later: "See later",
      accept: "Accept",
      smile: "Smile",
      smile_sent: "You have sent a smile to this user",
      continue: "Continue",
      featured_profiles: "Start making new friends!",
      nothing_to_show: "Nothing to show",
      see_more: "See more",
      see_less: "See less",
      of: "of",
      success_email: "Sent successfully, check your email.",
      error_email: "We can't find a user with that e-mail address.",
      accept_call: "Accept call",
      reject_call: "Stop call",
      profile_tables: {
        description: "Description",
        about_table: {
          me: "About {name}",
          ideal_couple: '{name}\'s perfect match'
        },
        personality_table: {
          me: "{name}\'s personality",
          ideal_couple: 'Personality of {name}\'s perfect match'
        },
        more_about_table: {
          me: "More about {name}"
        },
        about_me_table: {
          me: "About me",
          ideal_couple: "About my perfect match"
        },
        my_personality_table: {
          me: "My personality",
          ideal_couple: "Perfect match's personality"
        }
      },
      alert_message: {
        voice: "{username} is calling you.",
        video: "{username} is video calling you."
      },
      busy_call: {
        message: 'The user you are trying to call is busy, please try again later.',
        accept: 'Close'
      },
      calling: "Calling...",
      cancel_call: "Cancel call",
      months: "months",
      month: "month",
      monthly: "monthly",
      biweekly: "Biweekly",
      days: "days",
      save: "Save",
      "get_start": "Get Started",
      cancel: "Cancel",
      visits:
        "Find out who has visited your profile and shown interest in getting to know you.",
      year: "Year",
      are_you_sure: "Are you sure?",
      cancel_alert:
        "Do you want to cancel your subscription and no longer have all the benefits of JWPerfectMatch?",
      yes_cancel: "Yes, cancel it",
      no_keep: "No, keep it",
      register: "Registration",
      create_profile: "Create your profile",
      save_and_finish: "Save and finish",
      save_and_continue: "Save and Continue",
      stories_happy: "Love Stories",
      yes: "Yes",
      no: "Disabled",
      start_search: "Start search",
      labelusername:"Username",
      message_search:
        "Get access to all the functions and advantages we offer you! You can exchange text messages, voice and enjoy video chat. You'll love it!",
      order_by: "Order by",
      message_tell_friends:
        "Hi, I want to share with you the online dating site for genuine Jehovah's Witnesses JWperfectmatch! It was designed to take care of the cleanliness within the congregation of single brothers and sisters worldwide. Since there are specific filters to accept active Jehovah's Witnesses only, a lot of brothers and sisters are using it. It is easy to use; you can join for free; and best of all, this secure and reliable site will keep your data and information private and secure.",
      sent_success: "Message sent succesfully!",
      message_delete_profile:
        "If you wish to unsubscribe from JWPerfectMatch and completely and permanently delete your profile you can",
      delete_profile: "delete profile",
      description: "Your Description",
      education: "Education",
      heart_logo_message:
        `Look beyond, try to find the secret person of the heart<br/> <tooltip :customClasses="['text-jpink-primary']" message="but let it be the secret person of the heart in the incorruptible adornment of the quiet and mild spirit,  which is of great value in the eyes of God">(1 Peter 3:4)</tooltip>`,
      download_app_title: "Download Now!",
      coming_app_title: "Coming Soon",
      no_messages: "No messages",
      connection: "Connection",
      complete_fields:
        "Please make sure you have answered all the questions completely.",
      band:
        "Subscribe and enjoy video calls, voice calls and text messages exclusively for Jehovah's Witnesses.",
      back: "Back",
      stories: 'Love stories',
      revision_pending: '-- Revision pending --'
    },
    complaints: {
      title: "Report harassment",
      subtitle: "Your safety is our priority",
      description:
        "We have received your message and it is under review. We will let you know if any further information is needed.",
      message:
        "Whether it is inappropriate behavior or a severe incident, we ask you to report it immediately and confidentially by filling out the form below.",
      other_reason:
        "If you want to contact our support team for another request, click here",
      click_here: "Click here",
      form: {
        type_complaint: {
          label: "Contact type",
          types: {
            inappropiate_behavior: "I want to report a user for inappropiate behavior",
            serious_incident: "I want to report a serious incident"
          }
        },
        your_name: "Your name",
        email: "Your email",
        username_report: "Reported username",
        complaint_subject: "Subject",
        your_complaint: "Your message",
        your_complaint_placeholder: "write your complaint"
      }
    },
    logout: {
      title: "Log out",
      cancel: "Cancel",
      accept: "Accept",
      satisfactions_title:
        "How satisfied are you with your session at JWPerfectMatch today?",
      satisfaction_one: "Very satisfied",
      satisfaction_two: "Somewhat satisfied",
      satisfaction_three: "Neither satisfied nor dissatisfied",
      satisfaction_four: "Somewhat dissatisfied",
      satisfaction_five: "Very unsatisfied"
    },
    stories: {
      title: "Success Stories Jwperfectmatch- Genuine Jw Dating Site",
      description: "Submit your success story here.",
      extra_description: "<b>JW Perfect Match</b> has strict  safety measures in place to guarantee our <b>JW Singles</b> enjoy a secure <b>JW Dating</b> experience on our site.",
      register: "<u>Register Now</u> and be a part of the <b>best genuine Jehovah Witness Dating Site.</b>",
      result: "Stories result",
      return: "return to stories",
      form: {
        title: "Story Title",
        placeholder: "My precious life, the only one, the true love",
        description: "Description of its history",
        body: "My story",
        publish: "Submit Your Success Story"
      },
      empty: "At the moment no stories have been written.",
      title_modal: "Your Story has been created",
      description_modal: "Your Story has been created and will be evaluated by JWPerfectMatch"

    },
    favorites: {
      result: "Favorite result"
    },
    form: {
      username: "Username",
      email: "Email",
      password: "Password",
      repeat_password: "Confirm Password",
      name: "Name",
      full_name: "Full Name",
      card_number: "Credit/Debit card number"
    },
    welcome: {
      title_line_one: "Welcome to JWperfectmatch!",
      title_line_two: "The dating site for single Jehovah's Witnesses",
      main_message:
        "On <strong>JWperfectmatch</strong>, our goal is to bring together active and baptized members of the congregation of Jehovah's Witnesses worldwide, interested in building an authentic loving relationship based on principles, respect, and obedience to the moral standards and discipline from Jehovah God.",
      second_message:
        "By clicking on \"Continue,” you certify that all the information provided is true and accurate, and that you are currently a baptized and active Jehovah's Witness*. You agree to the Terms and conditions of use, Privacy policy, Safety guidance, and answers to Frequently Asked Questions on this site",
      disclaimer:
        "*We consider an active Jehovah's Witness a person who boldly preaches the good news of the Kingdom and regularly attends weekly meetings at the Kingdom Hall of Jehovah's Witnesses. Also, he/she must respect, promote, and live according to biblical principles observing the rules of conduct followed within the Congregation of Jehovah's Witnesses."
    },
    verify: {
      title: "Verify your mobile number",
      description:
        "Increase the level of trust in your user profile. We encourage you to verify your mobile phone number to create a trusting and secure environment within the website.",
      mobile_phone: "Mobile phone",
      confirm: "Confirm mobile number",
      later: "I will do it later",
      introduce_code: "Enter verification code",
      example: 'Example: 1234',
      incorrect_code: "Incorrect verification code",
      verified: "Verified",
      mobile_verified: "Your mobile phone number was verified correctly",
      change: "Change phone number"
    },
    find_match: {
      title: "Ways to Find a Perfect Match",
      compatibility_title: "JW Dating Compatibility Search",
      compatibility_content:
        'Find your potential JWperfectmatch with our new "JWperfectmatch search" engine. It will help you find other users.',
      videocalls_title: "Video calls and more",
      videocalls_content:
        "Contact other JW users through video calls, voice calls, and messages when you subscribe. Now you will not need to share your mobile phone number to do so!",
      private_message_title: "Private Messaging",
      private_message_content:
        "Contact other users using our private messaging system whenever you want! Our JWperfectmatch private messaging system will help you to find your Perfect Match",
      discovery_title: "JW Dating, discover things in common",
      discovery_content:
        "Find out the things you have in common with other JW singles or potential matches instantly.",
      you_decide_title: "It's up to you",
      you_decide_content:
        "Block the users that does not meet your requirements or report someone who is annoying. With our JWperfectmatch  platform, You will always be in control!",
      add_favorites_title: "Add your favorite JW singles",
      add_favorites_content:
        "Add the users you like, to your Favorites private section and subscribe to contact them with our JW dating platform."
    },
    forgot_password: {
      title: "Did you forget your password?",
      description:
        "Enter your email and we will send you an email so you can change your password and create a new one.",
      email: "Email",
      recovery: "Change your password",
      reset: "The password has been updated"
    },
    upgrade: {
      title: "Go Premium!",
      description: "Add a Premium subscription and you’ll be able<br />to get a response from all non-subscribed users.",
      become_premium: "Go Premium"
    },
    subscription: {
      save_label : "SAVE NOW!",
      warning: "By confirming your subscription, you allow JWPOINT S.A DE C.V to charge your card for this payment and future payments in accordance with our terms and conditions of use. After {time} months, your subscription will automatically renew. You can cancel this anytime you want.",
      warning_singular: "By confirming your subscription, you allow JWPOINT S.A DE C.V to charge your card for this payment and future payments in accordance with our terms and conditions of use. After {time} month, your subscription will automatically renew. You can cancel this anytime you want.",
      warning_singular_day: "By confirming your subscription, you allow JWPOINT S.A DE C.V to charge your card for this payment and future payments in accordance with our terms and conditions of use. After {time} days, your subscription will automatically renew. You can cancel this anytime you want.",
      title_one: "Now it gets even more exciting!",
      title_two:
        "Upgrade your account and start talking with your perfect match.",
      advantage: "Advantages and new functions you will have access to when you subscribe and contact other subscribed members.",
      video_call_title: "Video calls and voice calls",
      video_call_content:
        "Make voice calls and video calls without sharing your mobile phone number on JWperfectmatch. We give you the privacy and security you ever wanted.",
      messages_title: "Unlimited messages and Emojis",
      messages_content:
        "Send unlimited messages and Emojis to express yourself.",
      couples_title: "More potential matches",
      couples_content:
        "Contact up to 1000 potential matches that meet your search criteria.",
      photos_title: "Photo access",
      photos_content:
        "Get access to all public and private photos of users who sent you an invitation to view their profile.",
      visits_title: "Profile visits",
      visits_content:
        "You can see who has visited your profile and has shown interest in meeting you. Subscribe!",
      security_title: "Security",
      security_content:
        "JWperfectmatch is a website for single Jehovah's Witnesses like you. Make unlimited calls without sharing your mobile phone number. Subscribe now!",
      choose: "Choose the subscription that works best for you",
      discount:
        "Add a Premium subscription for US $ 14.00 per month. With a premium subscription, everyone you send messages to can reply for FREE and this will increase your chances of finding a match. (Recommended)",
      support_message: "You are in good hands! Our support Team is made up of brothers and sisters, Jehovah's Witnesses, working for your safety and privacy.",
      upgrade: "Upgrade your account",
      subscription: "Subscription",
      coupon_individual: "{frecuency} month Subscription + {free} month for free",
      coupon_multiple: "Buy a {frecuency} month subscription and get {free}-month(s) for free",
      free_trial: "for free",
      single_charge: "Single charge",
      charge: "charge",
      premium_charge: "Premium charge",
      coupon_discount: "Coupon discount",
      will_pay: "Today's charge",
      billedInOne: 'Billed in one payment',
      cancel_subscription: "Cancel automatic renewal",
      update_payment_method: "Update payment method",
      banner_title: "Now you will enjoy all our services!",
      banner_description:
        "Get access to all the services we offer you! You can send messages, make unlimited video calls and more.",
      do_secure_payment: "Secure payment",
      do_secure_payment_or: "Or",
      invalid: {
        title: "Invalid coupon",
        description: "You are trying to buy a promo with an invalid coupon",
        button: "Go to subscriptions"
      },
      alert: {
        title: "Attention!",
        message: "Don't limit your possibilities! By disabling this option, you will not be able to contact or get responses from other unsubscribed users. Do you want to continue?",
        yes: "Yes",
        no: "No"
      },
      payment_terms: 'Renewal, cancellation and payment terms.',
      refund_policy: {
        title: 'Would you like to know our refund policy?',
        content: '<p>As a user, you have the right to receive a refund from us and without any type of penalty, if you send a written request within the next 12 hours after the date and time of your subscription start when you first subscribed. <b class="underline">This policy does not apply to subscription renewals</b>. If you wish to unsubscribe, you need to follow the procedure detailed at the section <b>"Is it possible to cancel the automatic renewal?"</b></p><p>12 hour cancellation policy. You, as a user of the website or buyer, can cancel your subscription and request a refund without penalty or obligation, at any time before the first 12 hours after the initial payment of your subscription has elapsed. <span class="underline">This policy does not apply to subscription renewals but only to your initial subscription</span>. If you wish to cancel your subscription and request a refund, you must send an email to <a class="mailto:support@jwperfectmatch.com">support@jwperfectmatch.com</a> within 12 hours after your initial subscription payment was made. Once you have made use of the JWperfectmatch.com communication platform through text messages, live chats, emojis, calls and video calls, send a smile (greeting) or add other users to your favorites, request for refund is not permitted. Once 12 hours or more have passed after you made your initial subscription payment, you will no longer be eligible for a full or partial refund.</p><p>The previous clause and the agreement on the maximum period of 12 hours to be reimbursed, will apply to subscriptions, Premium memberships, promotional discount coupons or promotions, and any payment for services that you can purchase on the website <a href="https://www.jwperfectmatch.com">www.jwperfectmatch.com</a> with the only exceptions being the gift subscriptions you have sent to other users and the 15-day subscription at US $ 15 with automatic renewal every 15 days. You cannot request a refund for the payment of one or more gift subscriptions that you have sent to other user(s), nor can you request a refund for the payment of the premium membership subscription for US $ 15 with automatic renewal every 15 days.</p><p>If you wish to cancel the automatic renewal of your membership, you must follow the procedure established under the section found within the Terms of Use: <b>Can I cancel the automatic renewal?</b> Remember that this functionality is not available within the mobile application, but only within the website.</p><p>Once the 12 hours have elapsed after your initial payment, you will not be eligible for a refund.</p><p>Any refund under the 12 hours cancellation policy will be issued within 15 days after the date the company had received your written request and cancellation notice. For more information, please read the Terms and conditions of use.</p><p>If your profile is removed or suspended by JMPOINT, the administration or representatives, or support personnel of the website <a href="https://www.jwperfectmatch.com">www.jwperfectmatch.com</a> or its providers because you have infringed, violated, or breached any of the terms and conditions of use, you may not receive any reimbursement or refund of payments you have made for the services on the website <a href="https://www.jwperfectmatch.com">www.jwperfectmatch.com</a>. By accepting the terms and conditions of use, you completely agree to this clause and accept that you will not receive any refund of the payment of your subscription, Premium membership, promotional or discount coupons, if you have breached, violated, or infringed one or more Terms and conditions of use of the website <a href="https://www.jwperfectmatch.com">www.jwperfectmatch.com</a>.</p><p>Any refund under the <b>twelve hour</b> cancellation policy will be issued within 15 days of the date the company received your request and notice of cancellation. You will receive a refund for the full amount that you have paid in full within the first 12 hours after the date and time of payment. Once more than twelve hours have passed from the date and time of your payment, you will not be able to receive a refund.</p><p>Cancellation for disability or death. If you cannot receive all the services you contracted, your heirs, you or your estate may choose to be exempt from continuing payments for the services of your subscription, except for those you had received before your death or at the onset of your disability if the disability had been determined by a physician to last more than six months. We will understand disability as a disorder that prevents you, as a user, from physically using the service provided by the website <a href="https://www.jwperfectmatch.com">www.jwperfectmatch.com</a>. You must provide a medical record from a physician hired and paid by you that represents a written proof, duly authenticated, which must be submitted in Spanish or English to the company that owns the website <a href="https://www.jwperfectmatch.com">www.jwperfectmatch.com</a>. If the disability may last six months or less, the company will not refund or cancel the payment of your subscription but will extend the duration of your subscription for a period equal to your disability or no longer than six months at no additional cost to you. If you have paid in advance for the months of service for a certain amount, and your death is proven through documentation, the company will refund your representative or family member the amount for the services you have not received. This will be done as soon as possible.</p>'
      },
      cancelation: {
        title: 'Is it possible to cancel the automatic renewal?',
        content: '<p>Remember that you can cancel the automatic renewal of your subscription whenever you decide. Please keep in mind that you must cancel the automatic renewal at least 72 hours before the end of your subscription term. If you fail to do so, your automatic renewal will not be canceled, and you will have to try the following month again. We require a 72-hour notice from you to cancel the automatic renewal due to scheduling of charges and processing of instructions in the system. By accepting the Terms and conditions of use and the Privacy policy, you confirm that you agree to this clause, and  you agree that you will not request a refund if you do not cancel the automatic renewal with 72 hours before the end of your subscription term. If you want to cancel your automatic renewal, click <a href="https://jwperfectmatch.com/en/cancel-renewal">here.</a> <b>This function is available only on the website and cannot be accessed through our mobile app.</b></p><p>Despite canceling the automatic renewal of your subscription, all the advantages of our service will be available until your subscription term expires. You can re-activate the automatic renewal function from your account settings page, at any time before the end of the subscription term.</p><p><strong>Coupons, vouchers, and promotional discounts will only apply to the first month of your subscription. After the first month of your subscription, the monthly payment will be billed according to the subscription plan you initially selected. If exceptionally, a coupon stipulates that the discount will be valid for a period longer than one month, this discount period will be respected.</strong></p><p>You will not be allowed to automatically renew any gift subscriptions that you pay and send to other users.</p>'
      }
    },
    terms_chat: {
      title: "Important announcement",
      description_one:
        "On JWperfectmatch, we want to protect you in your online experience on our website, and we need your help to do so. Please read and accept this important message before starting.",
      description_two:
        "I promise never to send money, request money from others, or share any financial information with any person or user I get to know on JWperfectmatch. Furthermore, I pledge to report to JWperfectmatch, any user asking me for money or financial information, as well as any person who doesn't display a conduct and morality expected from a Jehovah's Witness.",
      tips: "Get more safety tips"
    },
    tell_friends: {
      title: "Invite your friends",
      dialog_title: "Tell your friends",
      description:
        "... Or just fill out this form and we'll send them an invitation:",
      dialog_description:
        "Thank you, your invitation has been sent successfully. Feel free to share it with another JW friend",
      email: "Email of your friend",
      subject: "Subject",
      extra_message: "Message",
      placeholder_subject: "A website you should know",
      placeholder_message: "Hello (name of your friend)",
      placeholder_extra_message: "Write your message",
      upload_photos: "Upload Photos",
      fiends_email: "Or Just fill out this form and we'll send them an invitation via email:",
      share: {
        title: "Love never fails ... Let's share it!",
        intro: "Jehovah's Witnesses really like to give good news to others, don't we? JWperfectmatch has been created for genuine Jehovah's Witnesses like you. Our support team is made up of brothers and sisters  working hard  to maintain cleanliness within this website.",
        title2: "Sharing is caring!",
        intro2: "Share your good experiences of JWperfectmatch with other single & genuine Jehovah's Witnesses",
        twitter_message: "Join JWperfectmatch, the dating site for Genuine Jehovah's Witnesses. Managed by Jehovah's Witnesses.",
        facebook: "Facebook",
        twitter: "Twitter ",
        email: "Email"
      }
    },
    search: {
      title: "Search",
      description: {
        unsubscribed: "We have found people that meet your search criteria.",
        subscribed: "We have found people that meet your search criteria.",
      },
      i_am: "I am",
      interested: "Interested in",
      range: "Age range",
      live_ideal_couple: "Where does your perfect match live?",
      order: "Sort them by",
      start_search: "Start Search",
      labelusername:"Username",
      result: "Search result"
    },
    months: {
      0: "January",
      1: "February",
      2: "March",
      3: "April",
      4: "May",
      5: "June",
      6: "July",
      7: "August",
      8: "September",
      9: "October",
      10: "November",
      11: "December"
    },
    profile_tabs: {
      profile:
        'Your profile is <span class="text-jblue-secondary font-bold">{percentage}%</span> complete',
      complete_profile: "Complete profile",
      steps: {
        personal_information: "Personal information",
        about_you: "About you",
        education: "Education",
        my_ideal_couple: "My ideal couple",
        more_about_her: "More about her",
        more_about_him: "More about him",
        more_about_me: "More about me",
        your_picture: "Your pictures"
      },
      save: "Save",
      go_back: "Go back"
    },
    steps: {
      personal_information: "Personal Information",
      about_you: "About you",
      spiritual_qualities: "Spiritual Qualities",
      ideal_partner: "About Your Perfect Match",
      pictures: "Your picture",
      confirm_tj: "Confirm that you are JW"
    },
    step_one: {
      name: "First Name",
      last_name: "Last Name",
      email: "Email",
      username: "Username",
      password: "Password",
      confirm_password: "Confirm password",
      profile_message: "Profile message",
      birthdate: "Birth date",
      year: "Year",
      month: "Month",
      day: "Day",
      phone: "Phone Number",
      country: "Country",
      city: "City",
      postal_code: "Postal Code",
      verify_phone: "Confirm your mobile phone and become even more trustworthy.",
      terms:
        'I confirm and certify that I am a single and baptized Jehovah’s Witness over 18 years of age. I acknowledge that I have read and agree to the <span class="text-pink-500 font-semibold">Terms and Conditions of Use</span>, <span class="text-pink-500 font-semibold">Privacy Policy, answers to Frequently Asked Questions, Support and Safety Guidance</span>. I hereby give my consent to the processing of my personal data and the use of cookies as described in the <span class="text-pink-500 font-semibold">Privacy Policy</span>.',
      terms_and_conditions: "terms and conditions",
      indication_username:"Must be different from your name. Include only letters and numbers, no spaces, Minimum of 4 characters.",
      indication_name: "Use your full and correct name to avoid your profile being deleted.",
      indication_password:
        "Minimum of 8 characters. Include numbers, symbols, and Uppercase and Lowercase letters",
      indication_description:
        "maximum 10 words, only texts are allowed, alphanumeric signs or numbers are not allowed"
    },
    step_two: {
      title:
        "Completing your profile is very important. This is how your potential matches will get to know you better. Take your time and let your potential matches know who you are.",
      description: 'Avoid choosing the "other" option too often.'
    },
    step_four: {
      title:
        "Uploading photos of yourself will allow you to have more profile visits. Show your best smile!",
      description:
        "It is proven; you are 10 times more likely to be contacted if you have one or more photos on your profile, regardless of your appearance.",
      instructions: "Guidelines",
      instruction_1:
        "You must upload at least 1 recent photo of yourself. You can upload up to 10 photos when you subscribe.",
      instruction_2:
        "Your primary photo should be a portrait of you only, without written messages. It must be a clear and recent photo of your face and shoulders. You cannot upload the same photo repeatedly. Poor quality or low-resolution photos will not be accepted.",
      instruction_3: "Get rid of sunglasses. We do not accept photographs with masks.",
      instruction_4: "Make a mix of individual, social, and action shots.",
      instruction_5:
        "Make sure to add 4 or more photos to increase your matchmaking potential.",
      instruction_6: "Minimum acceptable dimensions are 600 x 600 pixels.",
      instruction_7: "You can upload your photos in JPG, JPEG, or PNG  format.",
      instruction_8:
        "Minimum acceptable dimensions are 600 x 600 pixels. The maximum size is 12 MB per photo, and the maximum available storage is 120 MB.",
      instruction_9:
        "None of your photos should be provocative, offensive, or protected by copyright.",
      instruction_10:
        "All photos are reviewed by our support team and will usually be available within the next 72 hours.",
      instruction_11:
        "If you try to upload photos that do not meet the standards included in our Terms and conditions of use, your user account may be blocked or deleted.",
      instruction_12:
        "Only you should appear. You cannot include other people in your photos.",

      profile_photo: "Profile photo",
      photo_approval_pending: "Photos approval pending.",
      options: {
        option_1: "I wish to make this my main photo.",
        option_2: "I wish this photo to be visible for everyone.",
        option_3: "I wish this photo to be visible only for my favorites.",
        option_4: "I wish this photo to be invisible for everyone.",
        option_5: "I wish to delete this photo."
      }
    },
    step_five: {
      title: "Help us to find your perfect match!",
      description: "Do not leave blank spaces. Describe your perfect match in as much detail as possible to have accurate results in your search.",
      ideal_couple_legend: "Your perfect match would respond this way if you asked him/her about:"
    },
    step_six: {
      title: "Confirm that you are a Jehovah's Witness.",
      description:
        "Now you can breathe! You have reached the last step in your JWperfectmatch registration",
      another_opportunity_title:
        "Oops! Apparently you have incorrectly answered one or more questions, but don't worry, you will have another chance.",
      another_opportunity_description:
        "Please answer the following two questions correctly",
      images: {
        file_upload_error: "Photo upload error."
      }
    },
    register_carousel: {
      one: "That wonderful feeling; romantic love based on principles!",
      two:
        "In the midst of this superficial world, The most important beauty, the interior! <br><tooltip message='But Jehovah said to Samuel: “Do not pay attention to his appearance and how tall he is, for I have rejected him. For the way man sees is not the way God sees, because mere man sees what appears to the eyes, but Jehovah sees into the heart.\"'>(1 Samuel 16:7)</tooltip>",
      three:
        'Jehovah\'s Witnesses are very happy people! <br><tooltip message="Happy are those conscious of their spiritual need, since the Kingdom of the heavens belongs to them.">(Matthew 5:3)</tooltip>',
      four:
        "It is proven; you are 10 times more likely to be contacted if you have photos on your profile.",
      five:
        'Look at the spiritual qualities, in "the secret person of the heart" <br><tooltip message=" but let it be the secret person of the heart, in the incorruptible adornment of the quiet and mild spirit, which is of great value in the eyes of God.">(1 Peter 3:4; </tooltip> <tooltip message="I pray that he may grant you through the abundance of his glory to be made mighty in the man you are inside, with power through his spirit">Ephesians 3:16)</tooltip>',
      six:
        'There is no greater privilege on earth than to be a witness in favor of the true God, Jehovah <br><tooltip message="“I am the One who declared and saved and made known When there was no foreign god among you. So you are my witnesses”,  declares Jehovah, “and I am God.”">(Isaiah 43:12)</tooltip>'
    },
    contact: {
      title: "Contact Us",
      disclaimer:
        'Before sending us any questions you may have, make sure you have read the <router-link class="text-pink-500 no-underline" to="/support">“Terms of Use and Frequently Asked Questions”.</router-link> In that sections, you will find the answers to most of the questions we receive from our users.',
      suggestion:
        "If you want to give us your suggestions, you will be welcome.",
      have_you_read: "Have you read the Terms of Use and the FAQ´s?",
      choose: "Choose answer",
      answer_one: "Yes, I have  read the Terms of Use and the FAQ´s",
      answer_two: "No, I have not read the Terms of Use and the FAQ´s",
      subject: "Subject",
      email: "Email",
      message: "Your message",
      message_placeholder: "Write your message a maximum of 500 words",
      continue: "Continue",
      dialog_title: 'Sent successfully',
      success: "We will get in contact as soon as possible.",
      mailto: "Send us a message to:"
    },
    chat: {
      default_answer: "Select a default answer",
      blocked: "Blocked!",
      blocked_message: "This user has blocked you.",
      audio: "You had a call with ",
      video: "You had a video call with ",
      ongoing: "Call in progress..."
    },
    coupons: {
      get_coupon: "Get coupon",
      coupon1: {
        title: "1-month free trial",
        description:
          "You are just one click away from getting to know your perfect match! Click on the following button NOW, so you can get access to free calls, video calls, and text messages during the first month."
      },
      coupon2: {
        title: "2-months for free",
        description:
          "Buy your 3-month subscription and get 2-month for free. Click on the following link to enjoy the complete list of services: voice calls, video calls, and free messages during the first two months of subscription."
      },
      coupon3: {
        title: "50% OFF",
        description: "Get 50% off on all 6 or 12-month subscriptions. Click on the following button to enjoy the complete list of services: free calls, video calls, and unlimited messages during the first half of your subscription period."
      },
      title: "Promotional Coupons",
      description:
        "Hurry up, limited time offer, you don't want to miss this. Upgrade your account and start enjoying all our benefits!"
    },
    success_dialog: {
      title: "Successful registration!",
      description:
        "Your registration was successful",
    },
    strike_dialog: {
      title: "Registration Information",
      description:
        "Oops! We are sorry; your answers were not correct. You can try again in 24 hours.",
      description_on_strike:
        "Oops! We are sorry; your answers were not correct. You can try again.",
      accept: "Accept"
    },
    banned_dialog: {
      title: "Registration Information",
      description:
        "Sorry, your answers have not been correct. If you wish, you can contact us at hello@jwperfectmatch.com and present your case for evaluation.",
      accept: "Accept"
    },
    home: {
      heading: 'JWperfectmatch is a dating site for Genuine Jehovah\'s Witnesses.',
      one:
        'Are you single because you want to obey the command to marry "Only in the Lord"?',
      two:
        `You can be confident that Jehovah is happy with your decision. <br><tooltip :customClasses="['text-jpink-primary']" message="Samuel then said: “Does Jehovah take as much pleasure in burnt offerings and sacrifices as in obeying the voice of Jehovah? Look! To obey is better than a sacrifice, and to pay attention than the fat of rams">(1 Samuel 15:22;</tooltip> <tooltip :customClasses="['text-jpink-primary']" message="Be wise, my son, and make my heart rejoice, So that I can make a reply to him who taunts me.">Proverbs. 27:11)</tooltip>`,
      three:
        `Jehovah has instructed that the congregation must be spiritually clean. <tooltip :customClasses="['text-jpink-primary']" message="Turn away, turn away, get out of there, and touch nothing unclean! Get out from the midst of her, keep yourselves clean, You who are carrying the utensils of Jehovah.">(Isaiah 52:11)</tooltip>`,
      four:
        `Jehovah's Witnesses do not consider dating to be a form of recreation, but a serious step towards marriage, which should honor Jehovah God. <tooltip :customClasses="['text-jpink-primary']" message="Do not become unevenly yoked with unbelievers. For what fellowship do righteousness and lawlessness have? Or what sharing does light have with darkness?">(2. Cor. 6:14)</tooltip>`,
      five:
        "On JWperfectmatch, our goal is to bring together active members of the congregation of Jehovah's Witnesses worldwide, interested in building a friendship or an authentic loving relationship in a safe and clean environment.",
      six:
        "JWperfectmatch is a site designed exclusively for single Jehovah's Witnesses. It will help you to find someone who meets your expectations and shares your same values, principles, love, and obedience to Jehovah."
    },
    edit_profile: {
      title: "General settings",
      personal_information: "General information",
      form: {
        first_name: "Name",
        last_name: "Last Name",
        full_name: "Full Name",
        email: "Email",
        username: "Username",
        password: "Password",
        country: "Country",
        phone: "Phone",
        zip_code: "ZIP/Postal Code",
        make_visible: "Make my profile visible to other users?",
        visible: "Visible",
        invisible: "Invisible",
        preferred_language: "My preferred language for this website"
      },
      couples: {
        title: "Potential matches - settings",
        show_users:
          "Show me only users who have visited the site in the last: ",
        is_important_photo:
          "Do I consider it important that the other person has a photo(s) in their profile?",
        accept_messages:
          'Would you accept messages from other users even if they don\'t meet any of your "non-negotiable" requirements?'
      },
      notifications: {
        title: "Do you want to receive email notifications about?",
        activity: "My profile activity",
        news: "Latest news and updates and new features",
        frequency: "Frequency of new potential matches notifications",
        discounts: "Discounts and promotional offers",
        notify: "Notofy a new message",
        guidance: "Guidance, recommendations, etc."
      },
      delete_profile: "Request to delete my profile",
      download_information: "Download my personal information",
      save_changes: "Save Changes"
    },
    gifts: {
      title: "Excellent decision!",
      description:
        "By sending a subscription gift to {name}, you express with actions that you are interested in {type}. {gender} can only use a temporary gift subscription for seven days to contact you.",
      message:
        "Add a Premium subscription for $ 14.00, so you can get a response from ALL THE PEOPLE to whom you send messages.",
      single_charge: "Single charge",
      subscription: "7 days subscription",
      gender: {
        male: "He",
        female: "She"
      },
      her: "her",
      him: "him"
    },
    payment_messages: {
      success: {
        title: "Your payment was successful!",
        body: "Your subscription payment was successfully processed."
      },
      error: {
        title: "Error!",
        body: "There was an error processing your payment, try again."
      },
      back_to_app: "Continue"
    },
    photos: {
      first_message: "Upload your photos",
      first_message_more: "Click here to upload more",
      second_message: 'Once uploaded, click on "Save"',
      my_photos: "My Photos",
      upload_photos: "Upload Photos"
    },
    has_photo_options: {
      nothing_important: "Not important",
      is_important: "Very important"
    },
    match_profile: {
      about_her: "About her personality",
      about_his: "About his personality",
      about_her_ideal_match: "Her ideal match's personality",
      about_his_ideal_match: "His ideal match's personality"
    },
    registration: {
      bad_news: "Bad news!",
      oops: "Oops!",
      continue_process:
        "Please answer the following questions to confirm that you are a Jehovah's Witness:",
      failed_attemps:
        "Sadly the registration process can`t be continued due to less correct answers than expected, thanks for trying.",
      wait_24:
        "After your first attempt, please wait 24 hours before retaking the test to prove that you are a Jehovah’s Witness.",
      used_link:
        "Oops! This link has already been used; therefore, the test cannot be recovered."
    },
    profile: {
      about_her: "About Her",
      about_him: "About Him",
      about_his_match: "About His Perfect Match",
      about_her_match: "About Her Perfect Match",
      not_found: "Not Found",
      profile_not_found: "The profile that you are looking for, doesn't exist.",
      close: "Close",
      spititual_goals: "{gender} Spiritual Goals",
      photos: {
        max_file_exceeded: {
          title: "The number of allowed photos was exceeded",
          description: "Remove some pictures and try again",
          accept: "Accept"
        },
        validation_error: "You must upload at least one photo of yourself. Make sure the photo meets the guidelines.",
        upload_error: "Pictures upload error, remove them or try again."
      }
    },
    gender: {
      her: "her",
      him: "him"
    },
    delete_photo: {
      title: 'Delete photo',
      description: 'Are you sure you want to delete your picture?',
      accept: 'Yes, I\'m sure',
      cancel: 'Cancel',
      onLessQuantity: {
        description: 'If you notice that all the images are blurred, it is because you can only see your matches and their profiles if you also have at least one photo. All photos will be blurry unless you also have at least one.',
        accept: 'Accept',
        cancel: 'Upload photo',
      }
    },
  },
  delete_user:{
    valueMemberModal: "you are a valued member of the JWperfectmatch family and we don't want to see you go!",
    didYouKnowModal: "For your convenience, your profile has a useful ‘invisible’ option, making your profile invisible to all other users. You can use this benefit at any time, without the need of closing your account. You can easily change this setting by clicking ‘edit profile’ on the top right hand corner of your profile page.",
    dontLeaveUsModal: "We don't want to see you go!",
    noKeepModal: 'No, keep it',
    yesDeleteModal: 'Yes, delete it!',
    fillTheFieldsModal: 'Please, fill the form',
    reasonsModal: 'Reasons why you want to delete your account',
    requestDeleteModal: 'Request Delete',
    completeTheFieldsModal: 'Please fill all the fields',
    requestCompleted: 'Your request has been sent',
  },
  muted: {
    title : "Profile under review",
    message: "Please try again later"
  },
  message_limit: {
    message:"Oops, looks like you have reached the daily limit of messages. By subscribing you can send  free text and unlimited number of chats to any user.<br> Subscribe today!"
  },
  edit_profile_limit: {
    message: "Subscribe to improve your profile!"
  },
  picture_limit: {
    message: "Subscribe now and make your profile even more attractive by uploading up to 10 pictures.",
    cancel : "Subscribe later",
    subscribe: "Subscribe now "
  }

};
export default en;
